<script setup lang="ts">
import '@/assets/styles/legal.css'
</script>

<template>
  <div class="legal-page">
    <section class="legal-card">
      <h1>Datenschutzerklärung</h1>

      <h2>1. Datenschutz auf einen Blick</h2>
      <p>
        Der Schutz Ihrer persönlichen Daten ist uns ein besonderes Anliegen.
        Wir verarbeiten Ihre personenbezogenen Daten ausschließlich auf Grundlage
        der gesetzlichen Bestimmungen (DSGVO, BDSG).
      </p>

      <h2>2. Verantwortlicher</h2>
      <p>
        Gallus Pflegedienst e.K.<br/>
        Nataša Markovic<br/>
        Am Niedwald 53<br/>
        65933 Frankfurt am Main<br/>
        E-Mail: info@galluspflegedienst.de<br/>
        Telefon: 06975009899
      </p>

      <h2>3. Hosting</h2>
      <p>
        Diese Website wird auf einem virtuellen privaten Server (VPS) bei folgendem
        Anbieter betrieben:
      </p>
      <p>
        IONOS SE<br/>
        Elgendorfer Straße 57<br/>
        56410 Montabaur<br/>
        Deutschland
      </p>
      <p>
        Die Verarbeitung erfolgt auf Servern innerhalb der Europäischen Union.
        Mit dem Hosting-Anbieter besteht ein Vertrag zur Auftragsverarbeitung
        gemäß Art. 28 DSGVO.
      </p>

      <h2>4. Erhebung und Verarbeitung personenbezogener Daten</h2>

      <h3>a) Kontaktformular</h3>
      <p>
        Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre
        Angaben inklusive der von Ihnen angegebenen Kontaktdaten zur Bearbeitung
        der Anfrage gespeichert.
      </p>
      <ul>
        <li>Name</li>
        <li>E-Mail-Adresse</li>
        <li>Nachricht</li>
      </ul>
      <p>
        Rechtsgrundlage:
        Art. 6 Abs. 1 lit. b DSGVO (Vertragsanbahnung) sowie
        Art. 6 Abs. 1 lit. f DSGVO (berechtigtes Interesse).
      </p>

      <h3>b) Bewerbungsformular</h3>
            <p>
              Wenn Sie sich über unser Bewerbungsformular bewerben, verarbeiten wir Ihre
              personenbezogenen Daten ausschließlich zum Zweck der Durchführung des
              Bewerbungsverfahrens.
            </p>
            <ul>
              <li>Name, Vorname</li>
              <li>E-Mail-Adresse</li>
              <li>Telefonnummer</li>
              <li>gewünschte Position</li>
              <li>Bewerbungsunterlagen (z. B. Lebenslauf)</li>
            </ul>
            <p>
              Rechtsgrundlage:
              Art. 6 Abs. 1 lit. b DSGVO sowie § 26 BDSG.
            </p>

      <h2>5. Speicherung und Löschung der Daten</h2>
      <p>
        Personenbezogene Daten werden nur so lange gespeichert, wie dies zur
        Erfüllung der jeweiligen Zwecke erforderlich ist.
      </p>
      <ul>
        <li>Kontaktanfragen: bis zur abschließenden Bearbeitung</li>
        <li>Bewerbungen: maximal 6 Monate nach Abschluss des Verfahrens</li>
      </ul>

      <h2>6. Weitergabe von Daten</h2>
      <p>
        Eine Weitergabe Ihrer Daten an Dritte erfolgt nicht, sofern keine
        gesetzliche Verpflichtung besteht.
      </p>

      <h2>7. SSL- / TLS-Verschlüsselung</h2>
      <p>
        Diese Website nutzt aus Sicherheitsgründen eine SSL- bzw. TLS-Verschlüsselung.
        Eine verschlüsselte Verbindung erkennen Sie an „https://“ in der Adresszeile.
      </p>

      <h2>8. Ihre Rechte</h2>
      <ul>
        <li>Auskunft über Ihre gespeicherten Daten</li>
        <li>Berichtigung oder Löschung</li>
        <li>Einschränkung der Verarbeitung</li>
        <li>Widerspruch gegen die Verarbeitung</li>
        <li>Datenübertragbarkeit</li>
      </ul>

      <h2>9. Widerruf Ihrer Einwilligung</h2>
      <p>
        Sie können eine bereits erteilte Einwilligung jederzeit widerrufen.
        Die Rechtmäßigkeit der bis zum Widerruf erfolgten Verarbeitung bleibt
        davon unberührt.
      </p>

      <h2>10. Google Maps</h2>
      <p>
        Diese Website nutzt den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited, Gordon House, Barrow
        Street, Dublin 4, Irland.
      </p>
      <p>
        Zur Nutzung der Funktionen von Google Maps ist es notwendig, Ihre IP-Adresse zu speichern. Diese Informationen
        werden in der Regel an einen Server von Google in den USA übertragen und dort gespeichert.
      </p>
      <p>
        Die Nutzung von Google Maps erfolgt im Interesse einer ansprechenden Darstellung unserer Online-Angebote und an
        einer leichten Auffindbarkeit der von uns angegebenen Orte. Dies stellt ein berechtigtes Interesse im Sinne von
        Art. 6 Abs. 1 lit. f DSGVO dar.
      </p>
      <p>
        Weitere Informationen zum Umgang mit Nutzerdaten finden Sie in der Datenschutzerklärung von Google:
        <a href="https://policies.google.com/privacy" target="_blank"
           rel="noopener">https://policies.google.com/privacy</a>
      </p>

      <h2>11. WhatsApp Kontakt</h2>
      <p>
        Für die Kontaktaufnahme bieten wir die Möglichkeit, über den Messenger-Dienst
        WhatsApp Kontakt aufzunehmen. Anbieter ist die WhatsApp Ireland Limited,
        4 Grand Canal Square, Grand Canal Harbour, Dublin 2, Irland.
      </p>

      <p>
        Wenn Sie über WhatsApp Kontakt mit uns aufnehmen, werden personenbezogene Daten
        wie Ihre Telefonnummer, Nachrichteninhalte sowie weitere Kommunikationsdaten
        verarbeitet und an WhatsApp bzw. Meta übertragen.
      </p>

      <p>
        Die Nutzung erfolgt freiwillig und auf Grundlage von Art. 6 Abs. 1 lit. a DSGVO
        sowie Art. 6 Abs. 1 lit. f DSGVO.
      </p>

      <p>
        Weitere Informationen zum Datenschutz bei WhatsApp finden Sie unter:
        <a
            href="https://www.whatsapp.com/legal/privacy-policy-eea"
            target="_blank"
            rel="noopener"
        >
          https://www.whatsapp.com/legal/privacy-policy-eea
        </a>
      </p>

    </section>
  </div>
</template>
